import {
  GET_USAGE_SUMMARY_REQUEST,
  GET_USAGE_SUMMARY_SUCCESS,
  GET_USAGE_SUMMARY_FAILURE,
  GET_USAGE_DAILY_REQUEST,
  GET_USAGE_DAILY_SUCCESS,
  GET_USAGE_DAILY_FAILURE,
  GET_USAGE_BY_MODEL_REQUEST,
  GET_USAGE_BY_MODEL_SUCCESS,
  GET_USAGE_BY_MODEL_FAILURE,
  GET_USAGE_BY_CAPABILITY_REQUEST,
  GET_USAGE_BY_CAPABILITY_SUCCESS,
  GET_USAGE_BY_CAPABILITY_FAILURE,
  GET_USAGE_BUDGET_REQUEST,
  GET_USAGE_BUDGET_SUCCESS,
  GET_USAGE_BUDGET_FAILURE,
  SET_USAGE_BUDGET_REQUEST,
  SET_USAGE_BUDGET_SUCCESS,
  SET_USAGE_BUDGET_FAILURE,
  GET_USAGE_PERMISSION_REQUEST,
  GET_USAGE_PERMISSION_SUCCESS,
  GET_USAGE_PERMISSION_FAILURE,
} from "./actions";
import { USER_LOGOUT_SUCCESS } from "../userLogin/actions";

const emptyTotals = { calls: 0, errors: 0, promptTokens: 0, completionTokens: 0, totalTokens: 0, costUsdPlatform: 0, costUsdByok: 0, costUsdTotal: 0 };

const initialState = {
  summary: emptyTotals,
  daily: [],
  byModel: [],
  byCapability: [],
  budget: null,
  permission: null,

  savingBudget: false,
  setBudgetResult: { success: true },

  pending: 0,
  loading: true,
  error: null,
};

const startLoading = (state) => ({ ...state, pending: state.pending + 1, loading: true });
const endLoading = (state, patch) => {
  const pending = Math.max(0, state.pending - 1);
  return { ...state, ...patch, pending, loading: pending > 0 };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USAGE_SUMMARY_REQUEST:
    case GET_USAGE_DAILY_REQUEST:
    case GET_USAGE_BY_MODEL_REQUEST:
    case GET_USAGE_BY_CAPABILITY_REQUEST:
    case GET_USAGE_BUDGET_REQUEST:
    case GET_USAGE_PERMISSION_REQUEST:
      return startLoading(state);

    case SET_USAGE_BUDGET_REQUEST:
      return { ...startLoading(state), savingBudget: true };

    case GET_USAGE_SUMMARY_SUCCESS:
      return endLoading(state, { summary: (action.payload.summary && action.payload.summary.totals) || emptyTotals });
    case GET_USAGE_SUMMARY_FAILURE:
      return endLoading(state, { error: action.payload.error });

    case GET_USAGE_DAILY_SUCCESS:
      return endLoading(state, { daily: (action.payload.daily && action.payload.daily.Items) || [] });
    case GET_USAGE_DAILY_FAILURE:
      return endLoading(state, { error: action.payload.error });

    case GET_USAGE_BY_MODEL_SUCCESS:
      return endLoading(state, { byModel: (action.payload.byModel && action.payload.byModel.Items) || [] });
    case GET_USAGE_BY_MODEL_FAILURE:
      return endLoading(state, { error: action.payload.error });

    case GET_USAGE_BY_CAPABILITY_SUCCESS:
      return endLoading(state, { byCapability: (action.payload.byCapability && action.payload.byCapability.Items) || [] });
    case GET_USAGE_BY_CAPABILITY_FAILURE:
      return endLoading(state, { error: action.payload.error });

    case GET_USAGE_BUDGET_SUCCESS:
      return endLoading(state, { budget: action.payload.budget });
    case GET_USAGE_BUDGET_FAILURE:
      return endLoading(state, { error: action.payload.error });

    case SET_USAGE_BUDGET_SUCCESS:
      return endLoading(state, { budget: action.payload.budget, savingBudget: false, setBudgetResult: { success: true } });
    case SET_USAGE_BUDGET_FAILURE:
      return endLoading(state, { savingBudget: false, setBudgetResult: { success: false, ...action.payload.error } });

    case GET_USAGE_PERMISSION_SUCCESS:
      return endLoading(state, { permission: action.payload.permission });
    case GET_USAGE_PERMISSION_FAILURE:
      return endLoading(state, { permission: { canAdd: false, canView: false, canEdit: false, canDelete: false } });

    case USER_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
